import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import { GoogleMap } from "../Global/Maps/GoogleMap";
import { io } from "socket.io-client";
import { useEffect, useState } from "react";
import { websocketPort } from "../../server/websocketPort";
import Theme from '../../styles/Theme/Theme';

const socket = io(websocketPort);

export const MapsWidget = () => {
    // const [incidents, setIncidents] = useState();
    const [realtimeBus, setRealtimeBus] = useState();

    // const { data: mapConfigurationData, isLoading: mapConfigurationLoading, refetch: refetchMapConfiguration } = useFetch(query.path.mapConfiguration, 'getMapConfiguration');
    const { data: incidentsData, isFetching: incidentsIsFetching, refetch: refetchIncidents } = useFetch('/incidents/map/items', 'getIncidents', {
        tenant: 'TOP/CASCAIS/CM CASCAIS',
    }, null, query.middlewareCommandURL);

    const { data: busData, isFetching: busIsFetching } = useFetch(query.path.realtimeBus, 'getRealtimeBus', null, 60000);
    useEffect(() => {
        if (busData) {
            setRealtimeBus(busData)
        }
    }, [busData])

    useEffect(() => {
        socket.on("manageIncident", (text) => {
            console.log("Refetch Incidents");
            refetchIncidents();
        });
    }, [])

    // if (!mapConfigurationLoading && mapConfigurationData.data?.styles && mapConfigurationData.data?.hide.length) {
    //     mapConfigurationData.data?.hide.map((el) => {
    //         mapStyles[mapConfigurationData.data?.styles].push(
    //             {
    //                 featureType: "poi." + el,
    //                 stylers: [{ visibility: "off" }],
    //             },
    //         )
    //     })

    // }

    return (
        <WidgetCard margin={Theme.spacing.videowall.xxs}>
            {/* {!incidentsIsFetching ? */}
            <GoogleMap configurations={mapConfiguration} incidents={incidentsData} realtimebus={realtimeBus} />
            {/* : <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>} */}
        </WidgetCard>
    )
}

const mapConfiguration = {
    "mapId": "15fb961c1d0a757",
    "lat": 38.710357,
    "lng": -9.369001,
    "zoom": 13.9,
    "disableDefaultUI": true,
    "heading": 10,
    "tilt": 0,
    "showTraffic": true,
    "showTransit": false,
    "showIncidents": true,
    "showRealTimeVehicle": false,
    "showTripUpdate": true,
    "showIncidentsTooltips": true,
    "showRealTimeVehicleTooltip": true,
    "styles": "default",
    "hide": [
        "attraction",
        "sports_complex",
        "place_of_worship",
        "business",
        "government",
        "medical",
        "park",
        "school",
        "shopping",
        "restaurant"
    ]
};